import { createAPI } from '@common'

export default {
  // 读频道列表
  getMamLoginBigData: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0mphjo0cjhEbub', 'get', config)
}
